/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Folder Closed Icon component.
 */
export const SystemFolderClosedIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M19.5 8.5625V17.3819C19.5 17.5293 19.4415 17.6706 19.3373 17.7748C19.2331 17.879 19.0918 17.9375 18.9444 17.9375H5.125C4.95924 17.9375 4.80027 17.8717 4.68306 17.7544C4.56585 17.6372 4.5 17.4783 4.5 17.3125V6.6875C4.5 6.52174 4.56585 6.36277 4.68306 6.24556C4.80027 6.12835 4.95924 6.0625 5.125 6.0625H9.29167C9.4269 6.0625 9.55848 6.10636 9.66667 6.1875L11.8333 7.8125C11.9415 7.89364 12.0731 7.9375 12.2083 7.9375H18.875C19.0408 7.9375 19.1997 8.00335 19.3169 8.12056C19.4342 8.23777 19.5 8.39674 19.5 8.5625Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default SystemFolderClosedIcon;
